// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"53ffc754","839":"6a80fe01"}[chunkId] + ".chunk.js";
};